import { render, staticRenderFns } from "./CardContentRepeater.vue?vue&type=template&id=56027d31&scoped=true"
import script from "./CardContentRepeater.vue?vue&type=script&lang=js"
export * from "./CardContentRepeater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56027d31",
  null
  
)

export default component.exports